import { AuthService } from '$services/auth/auth.service'
import { IconsService } from '$services/icons/icons.service'
import { HorseSex, PostDisplay, User } from '$types'
import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core'

@Component({
  selector: 'app-post-display',
  templateUrl: './post-display.component.html',
  styleUrls: ['./post-display.component.css']
})
export class PostDisplayComponent implements OnInit {

  @Input() post!: PostDisplay
  @Input() moderatorMode!: boolean
  @Output() renewPost = new EventEmitter<PostDisplay>()
  @Output() updatePost = new EventEmitter<PostDisplay>()
  @Output() deletePost = new EventEmitter<PostDisplay>()
  @HostBinding('class.almost-expired') almostExpired: boolean = false
  @HostBinding('class.expired') expired: boolean = false
  @HostBinding('class.owned') owned: boolean = false

  imageIsloaded: boolean = false
  hasPhoto: boolean = false
  user?: User
  editable: boolean = false
  SexEnum: typeof HorseSex = HorseSex

  constructor(
    private readonly icons:IconsService,
    private readonly authService: AuthService) {

    this.icons.registerIcon([
      `pencil`, `file-alert`,
      `trash`, `check`,
      `male`, `female`,
      `letter-h`, `attele`,
      `monte`, `record`,
      `money`, `horse-placeholder`,
      `currency-euro`, `currency-euro-free`,
      `history`, `history`,
      `globe`])
  }

  ngOnInit(): void {
    this.user = this.authService.user ? this.authService.user : undefined
    this.hasPhoto = this.post.photos != null && this.post.photos.length > 0
    this.editable = this.post.idClient === this.user?.id
    this.owned = this.editable
    this.processExpiration()
  }

  private processExpiration(){
    if(!this.post.expireAt || !this.owned){
      return
    }

    this.expired = this.post.expired
    this.almostExpired = this.post.almostExpired
  }
}
